import React, { useState } from "react";
import "../Styles/requisition.css";
import TopNav from "../layouts/TopNav";
import CustomerModal from "../components/Modals/RequisitionModal/CustomerModal";
import PaymentModal from "../components/Modals/RequisitionModal/PaymentModal";
import ProductModal from "../components/Modals/RequisitionModal/ProductModal";
import { toast, ToastContainer } from "react-toastify";
import MVT from "../components/Modals/RequisitionModal/MVT";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ReLoginModal from "../components/ReLoginModal";
import RequisitionIcon from "../asset/svg/requisitionIcon";
import api from "../util/axios";

type Customer = {
  businessName: string;
  _id: string;
  customerAccount: any;
  customer: string;
  state: string;
  country: string;
  fullPament: string;
  halfPayment: string;
};

type Product = {
  name: string;
  description: string;
  unitOfMeasure: string;
  category: string;
  price: any;
  quantity: string;
  _id: string;
  product: any;
};

const Requisition = () => {
  const navigate = useNavigate();
  const [reLogin, setReLogin] = useState(false);
  // customer

  const [opCus, setOpCus] = useState(false);

  const handleCusModal = () => {
    setOpCus(!opCus);
  };

  const [selCus, setselCus] = useState<Customer | null>(null);

  const handleCusSelect = (data: any) => {
    setselCus(data);
    setOpCus(false);
  };
  const [opPay, setOpPay] = useState(false);

  const handlePayModal = () => {
    setOpPay(!opPay);
  };

  const [selPay, setselPay] = useState("");

  const handlePaySelect = (data: any) => {
    setselPay(data);
    setOpPay(false);
  };

  // MVT Type

  const [opMvt, setOpMvt] = useState(false);

  const handleMvtModal = () => {
    setOpMvt(!opMvt);
  };

  const [selMvt, setselMvt] = useState("");

  const handleMvtSelect = (data: any) => {
    setselMvt(data);
    setOpMvt(false);
  };

  // product
  const [opPro, setOpPro] = useState(false);

  const handleProModal = () => {
    setOpPro(!opPro);
  };

  const [selPro, setselPro] = useState<Product | null>(null);

  const handleProSelect = (data: any) => {
    setselPro(data);
    // console.log('lll', data)
  };

  // product QUantity
  const [opProQuan, setOpProQuan] = useState(false);

  const handleProQuanModal = () => {
    setOpProQuan(!opProQuan);
  };

  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;

  // request
  const [loading, setLoading] = useState(false);

  const [sign, setSign] = useState({
    customer: "",
    businessType: "oil and gas",
    paymentType: "",
    mvtType: "",
    requisitionTime: "",
    itemId: "",
    quantity: "",
  });

  const handleChange = ({ target: { name, value } }: any) => {
    setSign((prevSign) => ({
      ...prevSign,
      [name]: value,
    }));
  };
  const datas = {
    customer: selCus?._id,
    businessType: sign.businessType,
    paymentTerms: selPay,
    mvtType: selMvt,
    requisitionTime: formattedDate,
    items: [
      {
        _id: selPro?._id,
        quantity: sign.quantity,
        describtion: selPro?.description,
      },
    ],
  };

  const token = window.localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!datas.customer) {
      toast.error("Please select a customer")
      return;
    }
    if (!datas.paymentTerms) {
      toast.error("Please select a payment term")
      return;
    }
    if (!datas.mvtType) {
      toast.error("Please select MVT Type")
      return;
    }
    if (!datas.items[0]._id) {
      toast.error("Please select Product!")
      return;
    }
    setLoading(true);

    api
      .post("/requisition", datas, {
        headers: headers,
      })

      .then((res) => {
        // console.log(res);
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
          // cancelButtonText: "Leave Page",
        });
        setLoading(false);

        navigate("/dashboard/approval");
      })
      .catch((err) => {
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          // cancelButtonColor: "red",
          confirmButtonText: "Try Again",
          // cancelButtonText: "Leave Page",
        });
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          toast.error('Session expired, please log in again.');
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setLoading(false);
      });
  };

  const checkingQuan = selCus?.customerAccount.map((de: any) => de);

  return (
    <div className="board !bg-gray-100">
      <ToastContainer />
      <TopNav title="Requisition" />

      {reLogin ? <ReLoginModal /> : null}
      <div className="flex justify-between !h-screen p-10 rounded-lg shadow-lg">
        <div className="p-10 !w-6/12 bg-white">
          <h1 className="text-2xl text-blue-600">Create Requisition</h1>
          <hr />

          <form onSubmit={handleSubmit} className="requi !w-full">
            <div className="requiTab1 ">
              <div>
                <div className="reqInpt1 !w-full">
                  <label>Select Customer</label>
                  <div className="requInput">
                    <input
                      type="text"
                      disabled
                      required
                      name="customer"
                      value={selCus ? selCus.businessName : ""}
                      onChange={handleChange}
                    />
                    <button type="button" onClick={handleCusModal}>
                      select
                    </button>
                  </div>
                </div>
                <div className="reqInpt1">
                  <label>Payment Terms</label>
                  <div className="requInput">
                    <input
                      type="text"
                      disabled
                      required
                      name="paymentTerms"
                      value={selPay}
                      onChange={handleChange}
                    />
                    <button type="button" onClick={handlePayModal}>
                      select
                    </button>
                  </div>
                </div>
                <div className="reqInpt1">
                  <label>MVT Type</label>
                  <div className="requInput">
                    <input
                      type="text"
                      disabled
                      required
                      name="mvtType"
                      value={selMvt}
                    />
                    <button type="button" onClick={handleMvtModal}>
                      select
                    </button>
                  </div>
                </div>
                <div className="reqInpt1">
                  <label>Select Product</label>
                  <div className="requInput">
                    <input
                      type="text"
                      disabled
                      name="customer"
                      value={selPro ? selPro?.name : ""}
                      onChange={handleChange}
                    />
                    <button
                      type="button"
                      onClick={handleProModal}
                      disabled={!selCus}
                      style={{ cursor: !selCus ? 'not-allowed' : 'pointer' }}
                    >
                      select
                    </button>
                  </div>
                </div>
              </div>
              <div>
              </div>
            </div>

            <div className="">
              <button type="submit" className="w-full bg-blue-500 hover:bg-blue-400 text-white font-semibold my-6 py-2 px-4 rounded">
                {loading ? (
                  <CircularProgress
                    size={20}
                    style={{ color: "#fff" }}
                  />
                ) : (
                  "Continue"
                )}
              </button>
              {/* <button className="catBtn2">Save</button> */}
            </div>
          </form>
        </div>

        <div style={{ backgroundColor: "#99B4C9" }} className="p-10 w-6/12 flex items-center justify-center">
          <RequisitionIcon />
        </div>
      </div>

      {opCus ? (
        <CustomerModal
          handleCusSelect={handleCusSelect}
          handleCusModal={handleCusModal}
          selCus={selCus}
        />
      ) : null}

      {opPay ? (
        <PaymentModal
          handlePaySelect={handlePaySelect}
          handlePayModal={handlePayModal}
          selPay={selPay}
        />
      ) : null}

      {opMvt ? (
        <MVT
          handleMvtSelect={handleMvtSelect}
          handleMvtModal={handleMvtModal}
          selMvt={selMvt}
        />
      ) : null}
      {opPro ? (
        <ProductModal
          handleProSelect={handleProSelect}
          handleProModal={handleProModal}
          selPro={selPro}
          handleProQuanModal={handleProQuanModal}
          opProQuan={opProQuan}
          handleChange={handleChange}
          sign={sign}
          setOpPro={setOpPro}
          checkingQuan={checkingQuan}
          customerID={selCus?._id}
        />
      ) : null}
    </div>
  );
};

export default Requisition;